import {
  Form,
  Table,
  Modal,
  Button,
  Container,
  InputGroup,
} from "react-bootstrap";
import axios from "axios";
import { DSHBRD } from "./styles";
import { toast } from "react-toastify";
import React, { useState } from "react";
import { getLanguage } from "../../utils/localization";
import { FaEye, FaSearch, FaTimes } from "react-icons/fa";
import LoadingSpinner from "../../components/GlobalLoading";
import { GET_CERTIFICATE_FOR_AIRTEL_URL } from "../../constants";

const Dashboard = () => {
  const [imei, setImei] = useState("");
  const [mobile, setMobile] = useState("");
  const [searchData, setSearchData] = useState([]);
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [mobileSearchCertificate, setMobileSearchCertificate] = useState([]);

  const handleClose = () => {
    setShowError(false);
  };
  const getCertificateByMobileNumberApi = () => {
    if (!mobile) {
      toast.error("Please enter Mobile Number to search.");
      return;
    }

    setIsLoading(true);
    axios({
      method: "GET",
      url: `https://portal.acrossassist.com/api/partner/v1/apb/getCertificateByMobileAndImei?imei=&mobileNumber=${mobile}`,
    })
      .then((res) => {
        console.log("322 ==== Mobile Res ====", res);
        if (res?.status === 200) {
          setSearchData(res?.data);
        } else {
          setErrorMessage("*No Certificate found for this Mobile number.");
          setShowError(true);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  const getCertificateByImeiApi = () => {
    if (!imei) {
      toast.error("Please enter IMEI to search.");
      return;
    }

    setIsLoading(true);
    axios({
      method: "GET",
      url: `https://portal.acrossassist.com/api/partner/v1/apb/getCertificateByMobileAndImei?imei=${imei}&mobileNumber=`,
    })
      .then((res) => {
        console.log("67 ==== Imei Res ====", res);
        if (res?.status === 200) {
          setSearchData(res?.data);
        } else {
          setErrorMessage("*No Certificate found for this IMEI number.");
          setShowError(true);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };
  const handleView = (Certificateid) => {
    setIsLoading(true);
    axios(
      `https://portal.acrossassist.com/api/partner/v1/apb/GetCertificateForAirtel?Certificateid=${Certificateid}`,
      { method: "GET", headers: { "Content-Type": "application/json" } }
    )
      .then((res) => {
        if (res?.status === 200) {
          window.open(res?.data, "_blank");
        }
        setIsLoading(false);
      })
      .catch((e) => {
        if (e?.response?.status === 400) {
          toast.error("*Invalid Certificate Id. Please try again.");
        }
        setIsLoading(false);
      });
  };
  // ****** Get Certificate List Api ******
  const getCertificateListApi = async () => {
    setIsLoading(true);

    axios(`${GET_CERTIFICATE_FOR_AIRTEL_URL}${mobile}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        console.log("108 ==== resp ====", res);
        if (res?.status === 200) {
          setMobileSearchCertificate(res?.data);
          toast.success(res?.data?.message);
          setIsLoading(false);
        }
        if (res?.status === 400) {
          toast.error(res?.data?.message);
          setIsLoading(false);
        }
        if (res?.status === 404) {
          toast.error(res?.data?.message);
          setIsLoading(false);
        }
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  return (
    <Container className="min-vh-100">
      <h5 className="text-left mb-4" style={DSHBRD.FNTS}>
        {getLanguage("DSHBRD.DSHBRD_HDNG")}
      </h5>

      <div className="d-flex flex-column flex-md-row gap-3">
        <InputGroup className="mb-4" style={{ height: 55, maxWidth: "500px" }}>
          <InputGroup.Text>
            <FaSearch />
          </InputGroup.Text>

          <Form.Control
            type="text"
            value={mobile}
            style={DSHBRD.FNTS}
            onChange={(e) => {
              setImei("");
              setMobile(e.target.value);
            }}
            placeholder={getLanguage("DSHBRD.SRCH_BY_MBL_PLCHLDR")}
          />
          {mobile && (
            <InputGroup.Text
              style={{ cursor: "pointer" }}
              onClick={() => {
                setMobile("");
                setSearchData([]);
                setMobileSearchCertificate([]);
              }}
            >
              <FaTimes />
            </InputGroup.Text>
          )}

          <Button style={DSHBRD.SRCH_BTNS} onClick={getCertificateListApi}>
            {getLanguage("DSHBRD.SRCH_BTN")}
          </Button>
        </InputGroup>

        <InputGroup className="mb-4" style={{ height: 55, maxWidth: "500px" }}>
          <InputGroup.Text>
            <FaSearch />
          </InputGroup.Text>
          <Form.Control
            type="text"
            value={imei}
            style={DSHBRD.FNTS}
            maxLength={15}
            onChange={(e) => {
              setImei(e.target.value);
              setMobile("");
            }}
            placeholder={getLanguage("DSHBRD.SRCH_BY_IMEI_PLCHLDR")}
          />
          {imei && (
            <InputGroup.Text
              style={{ cursor: "pointer" }}
              onClick={() => {
                setImei("");
                setSearchData([]);
                setMobileSearchCertificate([]);
              }}
            >
              <FaTimes />
            </InputGroup.Text>
          )}

          <Button style={DSHBRD.SRCH_BTNS} onClick={getCertificateByImeiApi}>
            {getLanguage("DSHBRD.SRCH_IMEI_BTN")}
          </Button>
        </InputGroup>
      </div>

      {/* {searchData?.length > 0 ? (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={DSHBRD.TBL_HDR_HDNG}>
                {getLanguage("DSHBRD.INDXNG")}
              </th>
              <th style={DSHBRD.TBL_HDR_HDNG}>
                {getLanguage("DSHBRD.CRTFCTENMBR")}
              </th>
              <th style={DSHBRD.TBL_HDR_HDNG}>
                {getLanguage("DSHBRD.CSTMRNME")}
              </th>
              <th style={DSHBRD.TBL_HDR_HDNG}>{getLanguage("DSHBRD.ACTNS")}</th>
            </tr>
          </thead>
          <tbody>
            {searchData.map((item, index) => (
              <tr key={index}>
                <td style={DSHBRD.TBL_HDR_VLU}>{index + 1}.</td>
                <td style={DSHBRD.TBL_HDR_VLU}>{item?.certificatesNumber}</td>
                <td style={DSHBRD.TBL_HDR_VLU}>{item?.customerName}</td>
                <td style={DSHBRD.TBL_HDR_VLU}>
                  <Button
                    size="sm"
                    variant="info"
                    onClick={() => handleView(item?.documentUrl)}
                  >
                    <FaEye />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Container className="d-flex justify-content-center align-items-center mt-4">
          <div style={DSHBRD.BLNK}>
            <img
              width="350"
              height="350"
              alt="No Results"
              src={require("../../assets/images/NoDataFound.jpg")}
            />
            <h6 className="mt-1" style={DSHBRD.FNTS}>
              {getLanguage("DSHBRD.CRTFCTE_BLNK_LBL")}
            </h6>
            <h6 style={DSHBRD.FNTS}>{getLanguage("DSHBRD.TRY_AGN_SBHDNG")}</h6>
          </div>
        </Container>
      )} */}

      {mobileSearchCertificate?.length > 0 ? (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={DSHBRD.TBL_HDR_HDNG}>
                {getLanguage("DSHBRD.INDXNG")}
              </th>
              <th style={DSHBRD.TBL_HDR_HDNG}>
                {getLanguage("DSHBRD.CRTFCTENMBR")}
              </th>
              <th style={DSHBRD.TBL_HDR_HDNG}>
                {getLanguage("DSHBRD.CSTMRNME")}
              </th>
              <th style={DSHBRD.TBL_HDR_HDNG}>{getLanguage("DSHBRD.ACTNS")}</th>
            </tr>
          </thead>
          <tbody>
            {mobileSearchCertificate.map((item, index) => (
              <tr key={index}>
                <td style={DSHBRD.TBL_HDR_VLU}>{index + 1}.</td>
                <td style={DSHBRD.TBL_HDR_VLU}>{item?.certificatesNumber}</td>
                <td style={DSHBRD.TBL_HDR_VLU}>{item?.customerName}</td>
                <td style={DSHBRD.TBL_HDR_VLU}>
                  <Button
                    size="sm"
                    variant="info"
                    onClick={() => handleView(item?.documentUrl)}
                  >
                    <FaEye />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : searchData?.length > 0 ? (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th style={DSHBRD.TBL_HDR_HDNG}>
                {getLanguage("DSHBRD.INDXNG")}
              </th>
              <th style={DSHBRD.TBL_HDR_HDNG}>
                {getLanguage("DSHBRD.CRTFCTENMBR")}
              </th>
              <th style={DSHBRD.TBL_HDR_HDNG}>
                {getLanguage("DSHBRD.CSTMRNME")}
              </th>
              <th style={DSHBRD.TBL_HDR_HDNG}>{getLanguage("DSHBRD.ACTNS")}</th>
            </tr>
          </thead>
          <tbody>
            {searchData.map((item, index) => (
              <tr key={index}>
                <td style={DSHBRD.TBL_HDR_VLU}>{index + 1}.</td>
                <td style={DSHBRD.TBL_HDR_VLU}>{item?.certificatesNumber}</td>
                <td style={DSHBRD.TBL_HDR_VLU}>{item?.customerName}</td>
                <td style={DSHBRD.TBL_HDR_VLU}>
                  <Button
                    size="sm"
                    variant="info"
                    onClick={() => handleView(item?.documentUrl)}
                  >
                    <FaEye />
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Container className="d-flex justify-content-center align-items-center mt-4">
          <div style={DSHBRD.BLNK}>
            <img
              width="350"
              height="350"
              alt="No Results"
              src={require("../../assets/images/NoDataFound.jpg")}
            />
            <h6 className="mt-1" style={DSHBRD.FNTS}>
              {getLanguage("DSHBRD.CRTFCTE_BLNK_LBL")}
            </h6>
            <h6 style={DSHBRD.FNTS}>{getLanguage("DSHBRD.TRY_AGN_SBHDNG")}</h6>
          </div>
        </Container>
      )}

      {/* Error Modal */}
      <Modal
        centered
        show={showError}
        onHide={handleClose}
        dialogClassName="custom-modal p-4"
      >
        <Modal.Header closeButton>
          <Modal.Title>{getLanguage("MDL.WARN")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="error-icon-container">
            <img
              alt="Error"
              width="50"
              height="50"
              src={require("../../assets/gif/Warning.gif")}
            />
          </div>
          <div style={{ color: "red" }}>{errorMessage}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="p-2 w-50" variant="primary" onClick={handleClose}>
            {getLanguage("MDL.CLSE")}
          </Button>
        </Modal.Footer>
      </Modal>

      <LoadingSpinner open={isLoading} />
    </Container>
  );
};

export default Dashboard;
